import React, { FC } from 'react'
import classNames from 'classnames'
import styles from './SwipeButtonsContainer.module.scss'
import { CardEntity } from '../../ducks/cards/types'

interface PropsType {
  cards: any[]
  addModal(card: CardEntity): void
  swipeCard(): void
}

const skipButtonClassNames = classNames(styles.button, styles.skip)
const stockButtonClassNames = classNames(styles.button, styles.stock)

const SwipeButtonsContainer: FC<PropsType> = ({ cards, swipeCard, addModal }) => {
  const clickAction = (action: string) => {
    swipeCard()

    if (action === 'skip') return
    addModal(cards[0])
  }

  return (
    <div className={ styles.swipeButtonsContents }>
      <div className={ styles.buttons }>
        <span className={ skipButtonClassNames } onClick={ () => clickAction('skip') }>
          <span className={styles.label }>スキップ</span>
        </span>
        <span className={ stockButtonClassNames } onClick={ () => clickAction('stock') } >
          <span className={ styles.label }>チェック</span>
        </span>
      </div>
    </div>
  )
}

export default SwipeButtonsContainer